module.exports = __webpack_public_path__ + "img/40_38_030_680.82d7adc1.jpg";